export default __webpack_public_path__ + "static/media/info-small.78f3983b.svg";